import { signal } from "@preact/signals-react";

import Dropdown from "componentsv2/form/Dropdown";
import ViewProducts from "apps/StaffSupply/components/ViewProducts";
import { useStore } from "storev2/formStore";
import { layoutStaffSupply } from "../../models/LayoutStaffSupply";
import proxy from "api/proxy";

const baseStoreId = "staff.product.product";
const productByPosition = signal([]);

function StepStart({ recId, employeeData }) {
  const { updateForm, newRecord } = useStore();
  const _layoutStaffSupply = layoutStaffSupply();

  const getStoreId = () => {
    return recId?.value || baseStoreId;
  };

  async function changeEmployee(employee) {
    console.log("🔍 changeEmployee - INICIO", { employee });

    const storeId = await newRecord(_layoutStaffSupply);
    recId.value = storeId;
    productByPosition.value = [];

    if (employee?.id) {
      const toActive = {
        id: storeId,
        employee: employee,
        "employee.party.id_number": employee["party."]?.id_number,
        position: employee["position."],
        state: "draft",
        "employee.operation_center.name": employee["operation_center."]?.name,
        "employee.department.name": employee["department."]?.name,
      };

      const toStore = {
        id: storeId,
        employee: employee.id,
        position: employee["position."]?.id,
        state: "waiting",
      };

      console.log("🔍 toActive:", toActive);
      console.log("🔍 toStore:", toStore);

      const { data: products } = await proxy.methodCall({
        model: "staff_supply.position_supply_line",
        method: "get_supplies_by_sex",
        args: [{ employee_id: employee.id }],
      });

      if (Array.isArray(products) && products.length > 0) {
        const groupedProducts = products.map((item) => {
          const category = item["category."]?.name ?? null;
          const quantity = item.quantity ?? 0;

          const sizes = [
            {
              id: null,
              code: "",
              name: "Talla",
              value: null,
            },
            ...(item["category."]?.["products."]?.map((prod) => {
              const sizeId = prod["size."]?.id ?? null;
              const sizeName = prod["size."]?.code ?? null;

              return {
                id: sizeId,
                code: prod.code,
                name: sizeName,
                value: {
                  id: prod.id,
                  code: prod.code,
                  name: prod.name,
                },
              };
            }) || []),
          ];

          return {
            id: item.id,
            name: category,
            quantity,
            size: sizes,
          };
        });

        productByPosition.value = groupedProducts;
      }

      updateForm(storeId, toActive, toStore);
    }
  }

  function searchEmployee(value) {
    return value ? [["party.name", "ilike", `%${value}%`]] : [];
  }

  return (
    <div className="max-w-[700px] mx-auto mt-[66px] mb-[300px]">
      <Dropdown
        attrs={[
          "party.name",
          "party.id_number",
          "category.name",
          "position.name",
          "department.name",
          "operation_center.name",
        ]}
        name="employee"
        label="company.employee.name"
        placeholder="Ingresa nombre o número de documento..."
        model="company.employee"
        recSearch={searchEmployee}
        data={employeeData}
        onChange={(_, value) => changeEmployee(value)}
        field={{ model: "company.employee" }}
      />

      {recId.value && (
        <ViewProducts
          products={productByPosition.value}
          storeId={getStoreId()}
        />
      )}
    </div>
  );
}

export default StepStart;
